<template>
  <div class="modal-backdrop">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ $t('connect') }} Email</h5>
          <button type="button" class="close" @click="close" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-row">
            <div class="form-group">
              <label>Email</label>
              <input type="text" placeholder="Email" v-model="email.login">
              <span class="error" v-if="errors.login">{{ errors.login[0] }}</span>
            </div>
            <div class="form-group">
              <label>{{ $t('password') }}</label>
              <input type="password" placeholder="Пароль" v-model="email.password">
              <span class="error" v-if="errors.password">{{ errors.password[0] }}</span>
            </div>
            <div class="form-group">
              <label>SMTP</label>
              <select class="custom-select small" v-model="email.smtp">
                <option value="">{{ $t('select-1') }} SMTP</option>
                <option value="smtp.yandex.ru">smtp.yandex.ru</option>
                <option value="smtp.mail.ru">smtp.mail.ru</option>
                <option value="smtp.rambler.ru">smtp.rambler.ru</option>
                <option value="smtp.gmail.com">smtp.gmail.com</option>
              </select>
              <span class="error" v-if="errors.smtp">{{ errors.smtp[0] }}</span>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label>SSL</label>
              <input type="checkbox" v-model="email.ssl">
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="close">{{ $t('close') }}</button>
          <button type="button" class="btn btn-primary" @click="submit">{{ $t('connect') }} Email</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'create-user-email',
  data: function(){
    return{
      email: {
        login: null,
        password: null,
        smtp: "",
        ssl: null,
      },
      errors: [],
    }
  },
  methods: {
    submit() {
      this.$store.dispatch('createMail', this.email).then(response => {
          if (response.status) {
              this.close();
              this.$store.dispatch('fetchMails');
              this.$toast.info("Токен для активации почты отправлен");
          }
          }).catch(error => {
            this.errors = error;
          });
    },
    close: function() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-header,
.modal-footer {
  padding: 15px;
  display: flex;
}

.modal-header {
  position: relative;
  border-bottom: 1px solid #eeeeee;
  color: #000000;
  justify-content: space-between;
}

.modal-footer {
  border-top: 1px solid #eeeeee;
}

</style>